/**
 * Fetch a resource from the network. Same as Window.fetch but automatically adds HTTP headers for
 * sending JSON data to the server and receiving JSON data back.
 * @param input Resource that you wish to fetch.
 * @param options Custom settings that you want to apply to the request. Correct headers for sending
 * data to the server are automatically added.
 * @returns Response to the request.
 */
export async function fetchWithJsonData(
    input: Request|URL|string,
    options?: RequestInit
): Promise<Response>{
    let userHeaders = {};
    if(options?.headers !== undefined){
        userHeaders = options.headers;
        delete options.headers;
    }

    const fullOptions: RequestInit = {
        headers: new Headers({
            /* eslint-disable @typescript-eslint/naming-convention */
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            /* eslint-enable @typescript-eslint/naming-convention */
            ...userHeaders
        }),
        ...options
    };

    return await fetch(input, fullOptions);
}